import React from 'react';
import ReactDOM from 'react-dom';

import App from './App.jsx';
import Firebase, { FirebaseContext } from './config/firebase';
import './constants/colors.css';
import './constants/fonts.css';
import './constants/globals.css';

ReactDOM.render(
    <FirebaseContext.Provider value={new Firebase()}>
        <App />
    </FirebaseContext.Provider>,
    document.getElementById('root')
);